import { render } from "./Bookings.vue?vue&type=template&id=51e8e608"
import script from "./Bookings.vue?vue&type=script&lang=js"
export * from "./Bookings.vue?vue&type=script&lang=js"
script.render = render

export default script